/**
 * Email Service Switch
 * Uses mock data when VITE_ENABLE_MOCK_DATA is true, otherwise real API.
 */
import config from '../config/config';

import * as realService from './emailService';
import * as mockService from './mockEmailService';

const svc = config.features.enableMockData ? mockService : realService;

export const getEmails = svc.getEmails;
export const getEmailById = svc.getEmailById;
export const createEmail = svc.createEmail;
export const updateEmail = svc.updateEmail;
export const deleteEmail = svc.deleteEmail;
